import React from 'react';
import { EventFieldType } from 'types/EventField';
import EventFieldTypeCheckbox from './EventFieldTypeCheckbox';
import EventFieldTypeDate from './EventFieldTypeDate';
import EventFieldTypeEmail from './EventFieldTypeEmail';
import EventFieldTypeSelect from './EventFieldTypeSelect';
import EventFieldTypeText from './EventFieldTypeText';
import EventFieldTypeTextarea from './EventFieldTypeTextarea';

interface EventFieldSwitcherProps {
  inputName: string;
  field: EventFieldType;
  disabled: boolean;
}

export interface EventFieldTypeProps {
  inputName: string;
  field: EventFieldType;
  disabled: boolean;
}

const EventFieldSwitcher: React.FC<EventFieldSwitcherProps> = ({
  inputName,
  field,
  disabled,
}) => {
  const eventFieldProps = {
    inputName,
    field,
    disabled,
  };
  switch (field.type) {
    case 'text':
      return <EventFieldTypeText {...eventFieldProps} />;
    case 'textarea':
      return <EventFieldTypeTextarea {...eventFieldProps} />;
    case 'date':
      return <EventFieldTypeDate {...eventFieldProps} />;
    case 'email':
      return <EventFieldTypeEmail {...eventFieldProps} />;
    case 'select':
      return <EventFieldTypeSelect {...eventFieldProps} />;
    // case 'file':
    //   return <EventFieldTypeFile {...eventFieldProps} />;
    case 'checkbox':
      return <EventFieldTypeCheckbox {...eventFieldProps} />;
    default:
      return <></>;
  }
};

export default EventFieldSwitcher;
